import React from "react";
import styled from "styled-components";
import cloudinary from "cloudinary-core";
import ImageLoader from 'react-imageloader';
import R from "ramda";
import Dropzone from "react-dropzone";
import request from "superagent";
import autobind from "autobind-decorator";

//------------------------------

const PRESET_NAME = "UnAuthed_LimitSize";
const CLOUDINARY_URL = "https://api.cloudinary.com/v1_1/codogo/upload";

var cl = cloudinary.Cloudinary.new({
	"cloud_name": "codogo",
});

const doggo = "http://i1.kym-cdn.com/entries/icons/original/000/002/203/20533_cooldog.jpg";
const PreloaderStyled = styled.div`
	background-color: ${ ({ theme, }) => theme.colors.white };
	background-image: url(${ doggo });
	width: ${ ({ width, }) => (width) }px;
	height: ${ ({ height, }) => (height) }px;
`;
const Preloader = ({ width, height, }) => () => (
	<PreloaderStyled
		width = { width }
		height = { height }
	/>
);

const ImageWrapper = styled.div`
	maxWidth: ${R.prop("width")}px;
	maxHeight: ${R.prop("height")}px;
	cursor: ${ ({ onUpload, isButton, }) => (
		(onUpload || isButton) ? "cursor" : "default"
	)};

	& img {
		max-width: 100%;
		max-height: 100%;
	}
`;

const uploadImgToCloudinary = (file) => {
	const upload = request.post(CLOUDINARY_URL)
		.field("upload_preset", PRESET_NAME)
		.field("file", file);

	return new Promise( (good, fail) => (
		upload.end((err, response) => {
			if(err) {
				fail(err);
			}

			if(response.body.public_id !== "") {
				good(response.body.public_id);
			}
		})
	));
}

//------------------------------

class CloudinaryImage extends React.Component {
	constructor(props){
		super(props);

		this.state = {
			displayUploader: false,
		};
	}

	@autobind
	changeToUploader(){
		this.setState({
			displayUploader: true,
		});
	}

	@autobind
	onImageDrop([ file, ]){
		uploadImgToCloudinary(file)
		.then( (cloudinaryID) => this.props.onUpload({
			cloudinaryID,
		}))
		.then( () => this.setState({
			displayUploader: false,
		}));
	};

	render(){
		const {
			cloudinaryID,
			height,
			isButton,
			onUpload,
			transformation,
			transformationPreScale,
			transformations,
			transformationsPreScale,
			url,
			width,
		} = this.props;

		const allTransformations = [
			...( transformationsPreScale || [] ),
			transformationPreScale,

			{
				crop: "fit",
				dpr: window.devicePixelRatio,
				"fetch_format": "auto",
				height: height,
				quality: "auto",
				width: width,
			},

			...( transformations || [] ),
			transformation,

		].filter(R.identity);

		const src = cl.url(
			url || cloudinaryID,
			{
				secure: true,
				type: url ? "fetch" : undefined,
				transformation: allTransformations,
			}
		);

		return (
			<ImageWrapper
				width = { width }
				height = { height }
				onUpload = { onUpload }
				isButton = { isButton }
				onClick = { !!onUpload && this.changeToUploader }
			>
				{
					(this.state.displayUploader)
					? (
						<Dropzone
							accept = "image/*"
							onDrop = { this.onImageDrop }
						>
							Drop an image, or click to select a file, to upload
						</Dropzone>
					)
					: (
						<ImageLoader
							src = { src }
							preloader = { Preloader({ width, height, }) }
							wrapper = { React.DOM.div }
							style = {{
								maxWidth: width,
								maxHeight: height,
							}}
						>
							Image load failed!
						</ImageLoader>
					)
				}
			</ImageWrapper>
		)
	}
}

CloudinaryImage.defaultProps = {
	width: 640,
	height: 480,
};

CloudinaryImage.commonTransforms = {
	smartSquare: {
		"aspect_ratio": 1,
		gravity: "auto",
		crop: "fill",
	},
};

export default CloudinaryImage;
